import api from 'api/axiosInstance';
import type { Paging } from 'types/pagination.types';

export type BeneficiaryContactType = {
  created: string;
  iban: string;
  modified: string;
  name: string;
  userId: string;
  __v: number;
  _id: string;
};

const getContactList = (
  params: Record<string, any>,
): Promise<{
  items: BeneficiaryContactType[];
  data: BeneficiaryContactType[];
  paging: Paging;
}> =>
  api
    .get('/v2/accountable-banking/search-beneficiaries', { params })
    .then((data: any) => ({
      ...data,
      data: data.items,
    }));

export default getContactList;
